import { faGavel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { RatingIndicator } from '@/shared/badges/export';

export default function EventBadges({ event }: { event: NewsEvent }) {
  return (
    <>
      {event.dataReleaseId && <RatingIndicator rating={event.rating} />}
      {event.auction && <FontAwesomeIcon icon={faGavel} className={'text-success-light'} />}
    </>
  );
}
